/**
 * TAMS Authenticate Middleware
 *
 * @since: 2018-03-20
 * @author: mk.ko
 *
 * @param isHMR
 * @param app
 * @param store
 * @param route
 * @param params
 * @param error
 * @param redirect
 * @returns {*}
 */

function setNewWindowMode ({$axios, store}) {
  const sessionToken = sessionStorage.getItem('SESSION_STORAGE_SET_TOKEN')
  const isToken = store.getters['common/authenticate/isAuthToken']
  // http header에 token 설정
  $axios.setToken(sessionToken)

  // TAMS
  store.dispatch('common/common/loadEventCode')
    .then(() => { store.dispatch('common/common/getUIData') })

  if (!isToken && !sessionToken) {
    window.close()
  }
}

function setGeWindowMode ({$axios, store, query}) {
  const sessionToken = sessionStorage.getItem('SESSION_STORAGE_SET_TOKEN')
  const isToken = store.getters['common/authenticate/isAuthToken']
  let isExistGeToken = store.getters['common/authenticate/isExistGeToken']
  // ge모드일때 암호화 키 null 값으로 ge모드의 동작을 위해 임시방편으로 사용
  if (_.isUndefined(store.state.common.authenticate.encryptionAesKey)) {
    store.state.common.authenticate.encryptionAesKey = ' '.repeat(32)
  }
  if (!isExistGeToken) {
    // http header에 token 설정
    $axios.setToken(sessionToken)
    const geToken = `${query.geWindow}`
    store.commit('common/authenticate/setGeToken', {
      geToken: geToken,
      authToken: sessionToken
    })

    // TAMS
    store.dispatch('common/common/loadEventCode')
      .then(() => { store.dispatch('common/common/getUIData') })
      .then(() => { sessionStorage.clear() })
    isExistGeToken = store.getters['common/authenticate/isExistGeToken']
  }
  // 다시 확인 필요
  if ((!isToken && !sessionToken) || !isExistGeToken) {
    window.close()
  }
}

function setNormalMode ({$axios, store, redirect, isDev}) {
  const
    sessionToken = sessionStorage.getItem('SESSION_STORAGE_SET_TOKEN'),
    sessionIssueDate = sessionStorage.getItem('SESSION_STORAGE_SET_ISSUE_DATE'),
    sessionRefreshToken = sessionStorage.getItem('SESSION_STORAGE_SET_REFRESH_TOKEN'),
    secuiHelperKey = sessionStorage.getItem('ENCRYPTION_AES_KEY'),
    csrfToken = sessionStorage.getItem('SESSION_STORAGE_SET_CSRF_TOKEN')
  const isToken = store.getters['common/authenticate/isAuthToken']

  // TAMS - secuiHelperKey, csrfToken 정상 여부 확인 (새창띄우기 이후 sessionStorage 공유로 재갱신 방지위함)
  const conditions = [sessionToken, sessionIssueDate, sessionRefreshToken, secuiHelperKey, csrfToken]
  if (conditions.every(condition => condition)) {
    // API Token 설정
    store.dispatch('common/authenticate/setToken', {
      token: sessionToken,
      issueDate: sessionIssueDate,
      refreshToken: sessionRefreshToken,
      secuiHelperKey: secuiHelperKey,
      csrfToken: csrfToken
    }).then(() => {
      sessionStorage.clear()
    }).then(() => {
      const storeToken = store.state.common.authenticate.authToken

      // http header에 token 설정
      $axios.setToken(storeToken)

      // TAMS
      store.dispatch('common/common/loadEventCode')
        .then(() => { store.dispatch('common/common/getUIData') })
    })
  } else {
    sessionStorage.clear() // TAMS
  }

  if (!isToken && !sessionToken) {
    if (isDev) {
      return redirect('/loginDev')
    } else {
      location.replace('/?redirect=True')
    }
  }
}

export default function ({isHMR, app, store, query, redirect, $axios, route, isDev}) {
  // 2018.11.08 김민수 - 다국어 코드 추가
  const sessionLang = sessionStorage.getItem('SESSION_STORAGE_SET_LANG')

  // 언어 설정
  if (sessionLang !== null) {
    store.commit('common/locale/setLang', sessionLang)
    app.i18n.locale = sessionLang
  }

  const isExistGeToken = store.getters['common/authenticate/isExistGeToken']

  if (route.fullPath) {
    const arrValue = route.fullPath.split('/')
    let menuKey = arrValue[arrValue.length - 1]
    if (menuKey.indexOf('?') !== -1) {
      menuKey = menuKey.split('?')[0]
    }
    $axios.setHeader('X-Gui-Menu', menuKey)
  }

  if ((query.geWindow || isExistGeToken) && _.get(store, ['state', 'common', 'common', 'apiPrefix', 'length'], 0) === 0) {
    store.commit('common/common/setApiPrefix', `/GE:${query.geWindow}/`)
  }

  // 새창 띄우기 시, 토큰 갱신하지 않음
  // sessionStorage 내 sessionToken 값 (axios header 용)
  // 새창 띄우기 설계 상 갱신된 토큰을 통해 이용해야할 경우 없음.
  if (query.newWindow && !query.hasOwnProperty('geWindow')) {
    setNewWindowMode({$axios, store})
  } else if (query.geWindow) {
    setGeWindowMode({$axios, store, query})
  } else {
    setNormalMode({$axios, store, redirect, isDev})
  }
}
